import Icon from 'veui/components/Icon'
import { IconPieChart } from 'dls-icons-vue'

Icon.register('pie-chart', IconPieChart)
